export type RealTimeTrendSettingModel = {
  PageNo: string;
  PenNo: string;
  IsShow: boolean;
  LineColor: string;
  PLCNo: string;
  AICardNo: string;
  ChannelNo: string;
  SettingNo: string;
  GraphScaleUpper: string;
  GraphScaleLower: string;
  ScaleNo: string;
  DispSpan: number;
  MachineIndex: string;
  MachineName: string;
  ItemName: string;
  OperationProcess: string;
  ClcTypeNo: string;
  RealTimeTrendValueUpper: string;
  RealTimeTrendValueUpperLimit: string;
  MeasureKindNo: string;
  UnitSymbol: string;
  Clc: number;
  EngineeringValueLower: string;
  EngineeringValueUpper: string;
  MultiplicationFactor: string;
  SpeedNo: number;
  LoggingPeriod: string;
  MeasureKindName: string;
  TypeNo: string;
  TypeName: string;
  Kind: number;

  IsRowSelect: boolean;
  IndexNo: number;
}

export const CreateDefaltRealTimeTrendSettingModel = (): RealTimeTrendSettingModel => {
  var ret: RealTimeTrendSettingModel = {
    PageNo: "",
    PenNo: "",
    IsShow: false,
    LineColor: "",
    PLCNo: "",
    AICardNo: "",
    ChannelNo: "",
    SettingNo: "",
    GraphScaleUpper: "",
    GraphScaleLower: "",
    ScaleNo: "",
    DispSpan: 0,
    MachineIndex: "",
    MachineName: "",
    ItemName: "",
    OperationProcess: "",
    ClcTypeNo: "",
    RealTimeTrendValueUpper: "",
    RealTimeTrendValueUpperLimit: "",
    MeasureKindNo: "",
    UnitSymbol: "",
    Clc: 0,
    EngineeringValueLower: "",
    EngineeringValueUpper: "",
    MultiplicationFactor: "",
    SpeedNo: 0,
    LoggingPeriod: "",
    MeasureKindName: "",
    TypeNo: "",
    TypeName: "",
    Kind : 0,

    IsRowSelect: false,
    IndexNo: 0,
  };

  return ret;
}


//リアルタイムトレンドのアイテム設定一覧を取得
export const GetRealTimeTrendSettingModelList = (gropuNo: string | unknown): Promise<RealTimeTrendSettingModel[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/RealTimeTrendSetting/" + gropuNo)
      .then((res) => res.json())
      .then((result: RealTimeTrendSettingModel[]) => {
        if (GetTrendManagementSettingTypeListValidate(result)) {

          console.debug(result);
          if (result.length != 8) {
            var count: number = result.length;
            for (let i = 0; i < (8 - count); i++) {
              result.push(CreateDefaltRealTimeTrendSettingModel());
            }
          }

          for (let i = 0; i < result.length; i++) {
            result[i].IndexNo = i;
            result[i].IsRowSelect = false;
          }

          resolve(result);
        }
        else {
          reject('Invalidate response');

        }
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const GetTrendManagementSettingTypeListValidate = (data: RealTimeTrendSettingModel[]) => {
  if (data == undefined) return false;
  return true;
};


export type GraphDataType = {
  PLCNo: string;
  AICardNo: string;
  ChannelNo: string;
  SettingNo: string;
  ValueDateTime: Date[];
  Value: number[];
  UpperValue: number;
  UpperLimitValue: number;
}

export type GraphDataListsType = {
  GraphDataList: GraphDataType[];
}

export const GetGraphDataListsType = (
  gropuNo: string | unknown,
  targetTime: string): Promise<GraphDataListsType> => {
  return new Promise((resolve, reject) => {

    var url: string = "api/RealTimeTrendGraphModels/" + gropuNo;
    var timeBetween = `?targetTime=${targetTime}`;

    console.debug(` GetGraphDataListsType -- ${url + timeBetween}`);
    fetch(url + timeBetween)
      .then((res) => res.json())
      .then((result: GraphDataListsType) => {
        if (GraphDataListsTypeValidate(result)) resolve(result);

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const GraphDataListsTypeValidate = (data: GraphDataListsType) => {
  console.log(`TrandSettings ckeck ${data}`);
  if (data == undefined) return false;
  console.log("TrandSettings ckeck ok");
  return true;
};
